import React, { useEffect, useState } from "react";
import StickyTitle from '../components/StickyTitle'
import ReactToPrint from "react-to-print";
import {
    InputLabel,
    FormControl,
    Button
} from "@mui/material";
import companylogo from "../../assets/company.png"

const DamageControlReportsPage = () => {

    const [damagedata, setDamagedata] = useState();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [filteredDamageData, setFilteredDamageData] = useState();

    const componentRef = React.createRef();

    useEffect(() => {
        const fetchDamages = async () => {
            try {
              const response = await fetch(`${process.env.REACT_APP_BASE_URL}/damages/all_damages`);
              const responseData = await response.json();
              if (responseData) {
                setDamagedata(responseData.damage);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          }
      
          fetchDamages();
    }, []);


    useEffect(() => {
        let filteredData = damagedata;

        if (fromDate && toDate) {
            filteredData = filteredData.filter(payment => payment.damagedate >= fromDate && payment.damagedate <= toDate);
        }
        setFilteredDamageData(filteredData);
    }, [damagedata, fromDate, toDate]);

    const calculateTotalPayments = (payments) => {
        return payments && payments?.reduce((total, payment) => total + parseInt(payment.damageamount), 0);
    };

    return (
        <>
            <StickyTitle no_button={true} title="Damage Control Reports" />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

                <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                    <div className='text-2xl ml-2 font-bold font-poppins'>Damage Control Reports</div>
                </div>
                <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                    <section>
                        <div className="bg-white p-5 rounded shadow">
                            <div className="flex flex-col justify-center">
                                <Button onClick={() => {
                                    setFromDate('')
                                    setFromDate('')
                                }} variant="contained" disableElevation>
                                    Clear Filters
                                </Button>
                                <InputLabel>From Date</InputLabel>
                                <FormControl>
                                    <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                </FormControl>
                                <InputLabel>To Date</InputLabel>
                                <FormControl>
                                    <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                </FormControl>

                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                            Generate Report
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                            </div>
                        </div>
                    </section>

                    <div className="damage__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                        <ReactToPrint
                            trigger={() => (
                                <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                    Print / Download
                                </button>
                            )}
                            content={() => componentRef.current}
                        />
                        <div
                            ref={componentRef}
                            className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                        >
                            <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                <div>

                                    <img  src={companylogo} alt="logo" />
                                </div>
                            </div>
                            <article className=" py-2 text-center text-base text-black border-t border-black uppercase w-full font-bold">
                                <p>Damage Control Report</p>
                            </article>


                            <table width="100%" className="mb-10">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                        <td className="font-bold">Damage Id</td>
                                        <td className="font-bold">Damage Item</td>
                                        <td className="font-bold">Qty</td>
                                        <td className="font-bold">Date</td>
                                        <td className="font-bold">Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredDamageData && filteredDamageData?.map((damage) => (
                                        <tr className=" text-center h-10" key={damage.id}>
                                            <td>{damage.id}</td>
                                            <td>{damage.damageitem}</td>
                                            <td>{damage.damagequantity}</td>
                                            <td>{damage.damagedate}</td>
                                            <td>{damage.damageamount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <td className=" font-bold text-md text-center" colSpan={2}>
                                    Total Payments: {calculateTotalPayments(filteredDamageData)}
                                </td>
                            </tr>
                            <tr className=" text-center h-10 font-bold mt-2">
                                <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                    Accountant
                                </td>
                            </tr>


                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default DamageControlReportsPage